<script lang="ts">
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import SectionTitle from "@kontextwerk/web-sdk/ui/typography/SectionTitle.svelte"

  type Props = {
    event: ScheduleEvent
    title: string
    description: string
    disabled?: boolean
  }

  let {
    event,
    title = $bindable(""),
    description = $bindable(""),
    disabled = false,
  }: Props = $props()

  const isAppointment = $derived(event.event_type === "APPOINTMENT")
</script>

<section class="event-details">
  <SectionTitle small={true} title="Details" style="margin-top: 0.8rem; margin-bottom: 0.25rem;" />
  <div class="row">
    {#if isAppointment}
      <Input
        placeholder="Titel / Betreff"
        value={event.title ?? ""}
        surfaceTone="dark"
        disabled={true}
        helperText="Automatisch erzeugt"
        tooltip="Der Kalendertitel wird aus Auftrag, Adresse und Terminstatus erzeugt."
      />
    {:else}
      <Input
        placeholder="Titel / Betreff"
        bind:value={title}
        surfaceTone="dark"
        {disabled}
        tooltip="Der Kalendertitel wird aus Auftrag, Adresse und Terminstatus erzeugt."
      />
    {/if}
  </div>

  <div class="row">
    <Input
      type="textarea"
      placeholder="Notizen / Beschreibung"
      bind:value={description}
      surfaceTone="dark"
      {disabled}
    />
  </div>
</section>

<style>
  .event-details {
    display: flex;
    flex-direction: column;
    gap: 0.55rem;
  }

  .row {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
  }

  .hint {
    margin: -0.2rem 0 0.25rem;
    color: var(--text-60);
    font-size: 0.84rem;
    line-height: 1.35;
  }
</style>
